import React from "react";
import { DailyCollectionReportContent } from '../../../Common/Table/tableContent';
import tokenService from '../../../../Common/tokenDecoder';

export default class ComponentToPrint extends React.Component {
    render() {

        const searchData = this.props.searchData;
        const resultData = this.props.data;
        const contentRowNames = this.props.rowNames;
        const permission = this.props.permission;
        const feildAvailabeDedauctionTypes = this.props.feildAvailabeDedauctionTypes;
        const weighDedauctionTypesTable = this.props.weighDedauctionTypesTable;
        const weighAvailabeDedauctionTypes = this.props.weighAvailabeDedauctionTypes;
        const totalSummaryRow = this.props.totalSummaryRow;

        function generateTotalRow() {

            var result = totalSummaryRow;

            var tempRes = [];

            contentRowNames.forEach((x, i) => {
                if (i > 5) {
                    for (var prop in result) {
                        if (prop === x) {
                            tempRes.push({ name: prop, value: result[prop] });
                        }
                    }
                }
            });

            if (result) {
                return (
                    <tr>
                        <th colSpan="6" style={{ fontWeight: "bold" }}>Total</th>
                        {contentRowNames.map(x => {
                            var res = tempRes.find(y => y.name === x.toString());
                            if (res) {
                                if (res.name === "lossGain" || res.name === undefined) {
                                    return (<th style={{ textAlign: "center" }}>-</th>)
                                }
                                else {
                                    return (
                                        <th style={{ textAlign: "end", fontWeight: "bold" }}>{parseFloat(res.value).toFixed(1)}</th>
                                    );
                                }
                            }
                        })}
                    </tr>
                );
            }
        }

        return (
            <div>
                <h3 className="pr-2"><center><u>Route Leaf Collection Details Report</u></center></h3>
                <div className="row pl-2 pb-4 pt-4">
                    <div className="col"><b>Group: </b> {searchData.group}</div>
                    <div className="col"><b>Route: </b> {searchData.route}</div>
                    <div className="col"><b>Factory: </b> {searchData.factory}</div>
                    <div className="col"><b>From Date: </b> {searchData.date}</div>
                    <div className="col"><b>To Date: </b> {searchData.toDate}</div>
                </div>
                <div className="row pl-2 pb-4 pt-4">
                    <div className="col"><b>Current Date: </b> {new Date().toLocaleString()}</div>
                    <div className="col"><b>User: </b> {tokenService.getUserNameFromToken()}</div>
                </div>
                {resultData.map((e, index) => {
                    return (
                        <div className="pt-2 pl-2 pr-2 pb-3" key={index}>
                            <table
                                id="RouteLeafCollection_Pdf"
                                className="display dataTable">
                                <thead>
                                    <tr>
                                        <th rowSpan="2" style={{ fontWeight: "bold" }}>Date</th>
                                        <th rowSpan="2" style={{ fontWeight: "bold" }}>Time</th>
                                        <th rowSpan="2" style={{ fontWeight: "bold" }}>LT</th>
                                        <th rowSpan="2" style={{ fontWeight: "bold" }}>Tag</th>
                                        <th rowSpan="2" style={{ fontWeight: "bold" }}>RegNo</th>
                                        <th rowSpan="2" style={{ fontWeight: "bold" }}>Narration</th>
                                        <th colSpan={feildAvailabeDedauctionTypes.length + 3}
                                            scope="colgroup" style={{ fontWeight: "bold", textAlign: "center" }}>Field</th>
                                        <th colSpan={weighAvailabeDedauctionTypes.length + 3}
                                            scope="colgroup" style={{ fontWeight: "bold", textAlign: "center" }}>Factory</th>
                                        <th rowSpan="2" style={{ fontWeight: "bold" }}>G L/X</th>
                                        <th rowSpan="2" style={{ fontWeight: "bold" }}>L/G</th>
                                        {
                                            permission.isVarianceColumnEnabled ?
                                                <th rowSpan="2" style={{ fontWeight: "bold" }}>AG L/X</th> : null
                                        }
                                    </tr>
                                    <tr>
                                        <th scope="col" style={{ fontWeight: "bold" }}>Actual</th> : null
                                        <th scope="col" style={{ fontWeight: "bold" }}>Gross</th>
                                        {feildAvailabeDedauctionTypes.map((data, index) => {
                                            return (
                                                <th scope="col" style={{ fontWeight: "bold" }} key={index}>{data.split(' ').map(x => x[0]).join('')}</th>
                                            );
                                        })}
                                        <th scope="col" style={{ fontWeight: "bold" }}>Net</th>
                                        <th scope="col" style={{ fontWeight: "bold" }}>Actual</th>
                                        <th scope="col" style={{ fontWeight: "bold" }}>Gross</th>
                                        {weighDedauctionTypesTable.map((data, index) => {
                                            return (
                                                <th scope="col" style={{ fontWeight: "bold" }} key={index}>{data}</th>
                                            );
                                        })}
                                        <th scope="col" style={{ fontWeight: "bold" }}>Net</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <DailyCollectionReportContent
                                        data={e}
                                        contentRowNames={contentRowNames}
                                        hasEdit={false}
                                    />
                                </tbody>
                                <tfoot>
                                    {generateTotalRow()}
                                </tfoot>
                            </table>
                        </div>
                    )
                })}
            </div>
        );
    }
}